/**
 * Store module for handling deposit details
 * 
 * This module contains the state, getters, actions, and mutations for managing deposit details data. It uses the `httpHelper` module to fetch data from the API.
 *
 * @module store/deposit
 */
 import httpHelper from "@/helpers/httpHelper";

 /**
  * Action types for deposit details
  * @type {string}
  */
 export const DEPOSIT_DETAILS_ID = "depositDetailsId";
 export const DEPOSIT_WITH_ID = "depositWithId";
 
 /**
  * Mutation types for deposit details
  * @type {string}
  */
 export const SET_DEPOSIT_DETAILS_ID = "setDepositDetailsId";
 
 export default {
     state: {
         depoaitDetails:{},
     },
     /**
      * Getters for deposit details
      * @type {{loadedDepositDetails(*): *}}
      */
     getters: {
         /**
          * Get list of deposit details for current page
          * @param state
          * @returns {*}
          */
        
         loadedDepositDetails(state) {
             return state.depoaitDetails;
         },
     },
     /**
      * Actions for deposit details
      * @type {{[p: string]: function(*=, *=): Promise}}
      */
     actions: {
        
           /**
            * Action to fetch deposit details by id
            * @param state
            * @param payload
            * @returns {Promise<any>}
            */
           [DEPOSIT_DETAILS_ID](state, payload) {
             return new Promise((resolve, reject) => { httpHelper
                     .getData(payload)
                     .then((response) => {
                         state.commit(SET_DEPOSIT_DETAILS_ID, response);
                         resolve(response)
                     })
                     .catch((error) => {})
                     .finally(() => {});
                 })
         },
         /**
          * Action to fetch deposit details with id
          * @param state
          * @param payload
          * @returns {Promise<any>}
          */
         [DEPOSIT_WITH_ID](state, payload) {
             return new Promise((resolve, reject) => { httpHelper
                     .postData(payload.api,{tracking_number:payload.tracking_number,bank:payload.id})
                     .then((response) => {
                         resolve(response)
                     })
                     .catch((error) => {
                        reject(error)
                     })
                     .finally(() => {});
                 })
         },
     },
     /**
      * Mutations for deposit details
      * @type {{[p: string]: function(*=, *=)}}
      */
        mutations: {
            /**
            * Mutation to set deposit details
            * @param state
            * @param payload
            */
           [SET_DEPOSIT_DETAILS_ID](state, payload) {
               
               state.depoaitDetails = {...state.depoaitDetails,...payload.result};
               
           },
          
       }
}
   